import { DateResource } from '../../Date/Date';
import { PaginationResource } from './Resource';

export const strapiPreviewKeyParameter = 'previewKey';

export interface StrapiEntityData {
    id: number;
    documentId: string;
}

export interface StrapiDateData {
    createdAt: DateResource;
    publishedAt: DateResource;
    updatedAt: DateResource;
}

export interface StrapiEntity <T>{
    data?: T;
}

export interface StrapiMeta <T>{
    meta: T;
}

export enum QuerySortDirection {
    asc = 'asc',
    desc = 'desc',
}

export type QuerySortObject = Record<string, QuerySortDirection>;

export type QueryPaginationObject = Partial<Pick<PaginationResource, 'page' | 'pageSize'>>;
